// extracted by mini-css-extract-plugin
export default {"container":"EditorAlignment_container__TUSyI","button":"EditorAlignment_button__RgE13","active":"EditorAlignment_active__td-OL"};